import Chip from '@components/v2/ui/Chip/Chip';
import { Box } from '@mui/material';
import { useHorizontalOverflow } from '../../../../../hooks/useHorizontalOverflow/useHorizontalOverflow';
import ChipItem from './ChipItem';
import { CHIP_GAP_PX } from './chipList.constants';
import { ChipListItem, ChipListProps } from './chipList.types';

function ChipList({ items, trailingReservePx }: ChipListProps) {
  const { containerRef, measureRef, visibleCount, hiddenCount } = useHorizontalOverflow({
    itemCount: items.length,
    recalculationKey: items.map((item) => item.key).join('|'),
    gap: CHIP_GAP_PX,
    measureFrom: 'parent',
    minVisible: 1,
    extraReservePx: trailingReservePx ?? 0,
    trailer: { mode: 'measured' },
  });

  const visibleItems = items.slice(0, visibleCount);

  const measureChip = (item: ChipListItem) => <ChipItem key={item.key} item={item} />;

  const visibleChip = (item: ChipListItem) => <ChipItem key={item.key} item={item} isShrinkable />;

  return (
    <Box
      ref={containerRef}
      sx={{ position: 'relative', width: 'fit-content', maxWidth: '100%', minWidth: 0 }}
    >
      <Box
        ref={measureRef}
        aria-hidden
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          gap: `${CHIP_GAP_PX}px`,
          position: 'absolute',
          top: 0,
          left: 0,
          visibility: 'hidden',
          pointerEvents: 'none',
          alignItems: 'center',
        }}
      >
        {items.map(measureChip)}
        <Chip label={`+${items.length}`} size="small" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          overflow: 'hidden',
          alignItems: 'center',
          gap: `${CHIP_GAP_PX}px`,
          minWidth: 0,
          '& > *': { minWidth: 0 },
        }}
      >
        {visibleItems.map(visibleChip)}
        {hiddenCount > 0 && <Chip label={`+${hiddenCount}`} size="small" sx={{ flexShrink: 0 }} />}
      </Box>
    </Box>
  );
}

export default ChipList;
